module.exports = __webpack_public_path__ + "static/media/ashen.0c8d794b.jpg";